if (!process.env.VUE_APP_IS_WEB) {
  var MeetingGuestDB = require("../database/models/MeetingGuest");
}
import settings from "@/database/settings";
import strings from "@/database/strings";

import { _ } from "vue-underscore";
import MeetingGuestORM from "@/store/orm-axios/models/MeetingGuest";

export default {
  FETCH_ALL() {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MeetingGuestDB()
          .query({ where: { deleted: null } })
          .fetchAll()
          .then(res => {
            MeetingGuestORM.insertOrUpdate({
              data: res.serialize(),
            });
            return resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingGuestORM.api()
          .FETCH_ALL()
          .then(res => {
            resolve(res.response.data["hydra:member"]);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MeetingGuestDB()
          .query({ where: { deleted: null, meeting_id: meetingId } })
          .fetchAll()
          .then(res => {
            MeetingGuestORM.insertOrUpdate({
              data: res.serialize(),
            });
            return resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingGuestORM.api()
          .FETCH(meetingId)
          .then(res => {
            resolve(res.response.data["hydra:member"]);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MeetingGuestDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            let data = res.serialize();
            MeetingGuestORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingGuestORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async REGISTER(item) {
    return new Promise((resolve, reject) => {
      MeetingGuestORM.api()
        .REGISTER(
          JSON.stringify({
            email: item.email,
            generate: true,
            timezone: localStorage.getItem("timezone"),
          })
        )
        .then(res => {
          resolve(res.response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new MeetingGuestDB(itemPut)
          .save()
          .then(res => {
            let data = res.serialize();
            MeetingGuestORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingGuestORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new MeetingGuestDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            let data = res.serialize();
            MeetingGuestORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingGuestORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new MeetingGuestDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            MeetingGuestORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingGuestORM.api()
          .DELETE(item)
          .then(res => {
            MeetingGuestORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_BY_BUILDING(buildingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MeetingGuestORM.api()
          .GET_BY_BUILDING(buildingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
